import { useEffect, useState } from 'react';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import { LEADERBOARD_LIMIT } from 'root/src/shared/creatorDashboard/creatorDashboard.constants';
import { RedesignLayout } from 'root/src/client/v2/layout/features/RedesignLayout/RedesignLayout';
import { REDESIGN_NAV_OFFSET_CLASS } from 'root/src/client/v2/layout/helpers/redesignNavbar';
import { TooltipProvider } from 'root/src/client/v2/common/components/ui/tooltip';
import { Toaster } from 'root/src/client/v2/common/components/ui/sonner';
import { Skeleton } from 'root/src/client/v2/common/components/ui/skeleton';
import { cn } from 'root/src/client/v2/common/helpers/cn';
import { FilterTabs } from 'root/src/client/v2/_pages/publisher-creators/redesign/FilterTabs';
import { LeaderboardList } from 'root/src/client/v2/_pages/creators-leaderboard/redesign/LeaderboardList';
import { useLeaderboard } from 'root/src/client/v2/_pages/creators-leaderboard/redesign/hooks/useLeaderboard';
import { LEADERBOARD_DEFAULT_RANKING, RANKING_TAB_OPTIONS } from 'root/src/client/v2/_pages/creators-leaderboard/redesign/creatorsLeaderboard.helpers';
const DEFAULT_PAGE_SIZE = 10;
const LoadingRows = () => (<div className="flex flex-col gap-2">
		{[0, 1, 2, 3, 4, 5, 6, 7].map(key => <Skeleton key={key} className="h-16 w-full rounded-xl"/>)}
	</div>);
// Redesign of the creators leaderboard (`/creators-leaderboard`): ranking-type tabs + a paginated list
// of ranked creators. Reuses the existing `creatorDashboard.getCreatorsLeaderboard` procedure.
export const RedesignCreatorsLeaderboardPage = () => {
    const [rankingType, setRankingType] = useState(LEADERBOARD_DEFAULT_RANKING);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    useEffect(() => setPage(1), [rankingType, pageSize]);
    const { creators, pageCount, isLoading, isFetching, isError } = useLeaderboard({ page, pageSize, rankingType });
    return (<RedesignLayout>
			<TooltipProvider delayDuration={200}>
				<div className={cn('mx-auto w-full max-w-3xl px-4 pb-24', REDESIGN_NAV_OFFSET_CLASS)}>
					<header className="flex items-start gap-3 pt-8">
						<div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-solid border-white/[0.08] bg-white/[0.03] text-amber-300">
							<LeaderboardIcon sx={{ fontSize: 22 }}/>
						</div>
						<div>
							<h1 className="font-display text-2xl font-semibold text-foreground">Creators Leaderboard</h1>
							<p className="mt-1 text-sm text-muted-foreground">The top {LEADERBOARD_LIMIT} creators on Dare Drop.</p>
						</div>
					</header>

					<div className="mt-6 overflow-x-auto scrollbar-hide">
						<FilterTabs options={RANKING_TAB_OPTIONS} value={rankingType} onChange={value => setRankingType(value)} layoutId="leaderboardRankingTabs"/>
					</div>

					<div className="mt-4">
						{isError ? (<div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-destructive/30 px-6 py-16 text-center">
								<p className="text-sm font-semibold text-foreground">Could not load the leaderboard</p>
								<p className="mt-1 max-w-sm text-xs text-muted-foreground">Please refresh the page or try again in a moment.</p>
							</div>) : isLoading ? (<LoadingRows />) : (<LeaderboardList creators={creators} activeRanking={rankingType} page={page} pageCount={pageCount} pageSize={pageSize} onPageChange={setPage} onPageSizeChange={setPageSize} isFetching={isFetching} emptyTitle="No creators yet" emptyDescription="The leaderboard is empty for this ranking."/>)}
					</div>
				</div>
			</TooltipProvider>
			<Toaster />
		</RedesignLayout>);
};
